import DeletePlan from './DeletePlan'

export default DeletePlan